import type { FragmentType } from "@repo/graphql-types/fragment-masking";
import { useFragment } from "@repo/graphql-types/fragment-masking";
import { graphql } from "@repo/graphql-types/gql";
import { ListRoot } from "@/components/list";
import { PatientPaymentListItem } from "@/components/patient-payments-list-item";
import {
  EmptyStateV2Description,
  EmptyStateV2Root,
  EmptyStateV2Title,
} from "@/components/empty-state-v2";

export const PatientPaymentsListFragment = graphql(/* GraphQL */ `
  fragment PatientPaymentsListFragment on ExpensumGetPaymentsOutput {
    payments {
      codAgendamento
      ...PatientPaymentsListItemFragment
    }
  }
`);

interface PatientPaymentsListProps {
  data: FragmentType<typeof PatientPaymentsListFragment>;
}

export const PatientPaymentsList = ({ data }: PatientPaymentsListProps): JSX.Element => {
  const { payments } = useFragment(PatientPaymentsListFragment, data);

  return (
    <ListRoot>
      {payments.length === 0 ? (
        <EmptyStateV2Root>
          <EmptyStateV2Title>
            <>
              <h2>Ops! </h2>
              <h2>Não encontramos nada por aqui.</h2>
            </>
          </EmptyStateV2Title>
          <EmptyStateV2Description>
            Tente ajustar os filtros ou o período da busca para descobrir o que está
            procurando.
          </EmptyStateV2Description>
        </EmptyStateV2Root>
      ) : (
        payments.map((payment, index) => {
          if (payment) {
            return (
              <PatientPaymentListItem
                // eslint-disable-next-line react/no-array-index-key -- Não há identificar único
                key={`${payment.codAgendamento ?? 0}-${index}`}
                data={payment}
              />
            );
          }

          return null;
        })
      )}
    </ListRoot>
  );
};
